/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationRemoveSecretRequest
 */
export interface ApplicationRemoveSecretRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationRemoveSecretRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationRemoveSecretRequest
     */
    keyId?: string | null;
}

/**
 * Check if a given object implements the ApplicationRemoveSecretRequest interface.
 */
export function instanceOfApplicationRemoveSecretRequest(value: object): value is ApplicationRemoveSecretRequest {
    return true;
}

export function ApplicationRemoveSecretRequestFromJSON(json: any): ApplicationRemoveSecretRequest {
    return ApplicationRemoveSecretRequestFromJSONTyped(json, false);
}

export function ApplicationRemoveSecretRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationRemoveSecretRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'keyId': json['keyId'] === undefined ? undefined : json['keyId'] === null ? null : json['keyId'],
    };
}

export function ApplicationRemoveSecretRequestToJSON(json: any): ApplicationRemoveSecretRequest {
    return ApplicationRemoveSecretRequestToJSONTyped(json, false);
}

export function ApplicationRemoveSecretRequestToJSONTyped(value?: ApplicationRemoveSecretRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'keyId': value['keyId'],
    };
}

